<template>
  <UContainer class="mb-20">
    <ExpandableList v-slot="{ displayItems }" :items="schools" :limit="9">
      <CommonGridCards :items="displayItems" :pending="pending">
        <template #card="{ item }">
          <CommonCard
            :item="item"
            :to="`/directions/${item.id}`"
            image-top-left="lesson-types"
            image-top-right="rating"
            title-above-left="directions"
            :title-above-right="getLabelIcons(item)"
            :ui="{
              title: 'max-sm:line-clamp-1',
            }"
          >
          </CommonCard>
        </template>
      </CommonGridCards>
    </ExpandableList>
  </UContainer>
</template>

<script lang="ts" setup>
import ExpandableList from '~/components/ExpandableList.vue'
import type { IconWithLabel } from '~/types'
import type { School } from '~/api'

defineOptions({
  name: 'TrainerDetailSchools',
})

const route = useRoute()
const directoryStore = useDirectoryStore()
const { schools } = storeToRefs(directoryStore)

const { untilReady } = useRegionReady()

const { pending } = await useAppAsyncData(
  `trainer-schools-${route.params.id}`,
  async () => {
    await untilReady()
    await directoryStore.fetchSchools()
  },
)

const getLabelIcons = (item: School): IconWithLabel[] => [
  {
    icon: 'i-local-coach',
    label: 'Тренеры',
    value: item.trainers_count,
    to: `/schools/${item.id}/trainers`,
  },
]
</script>

<style lang="scss" scoped>
:deep(.common-card) {
  --card-height: 436px;
  --card-image-height: 240px;

  @include max-xl {
    --card-height: 358px;
    --card-image-height: 200px;
  }

  @include max-md {
    --card-height: 330px;
    --card-image-height: 160px;
  }
}
</style>
